const MUTATION_TYPE = {
  pushToasts: 'pushToasts',
  spliceToast: 'spliceToast',
  incCount: 'incCount'
}

const ACTION_TYPE = {
  pushToasts: 'pushToasts',
  delToast: 'delToast'
}

const GETTER_TYPE = {
  getToasts: 'getToasts',
  getCount: 'getCount'
}

export {
  MUTATION_TYPE,
  ACTION_TYPE,
  GETTER_TYPE
}
